import { RR_WEBVIEWER_FILE_STATES } from './webviewer-file-states.model';
import { RRWebviewerFileThreeD } from './webviewer-file-threed.model';
import { RRWebviewerJsonSingle } from './webviwer-json-single.model';

export class RRWebviewerFile {
  file:
    | string
    | Array<string>
    | RRWebviewerFileThreeD
    | Array<RRWebviewerFileThreeD>;
  type?: RR_WEBVIEWER_FILE_STATES;
  authToken?: string;
  baseUrl?: string;
  skybox?: boolean;
  ground?: boolean;

  constructor(
    file?:
      | string
      | Array<string>
      | RRWebviewerFileThreeD
      | Array<RRWebviewerFileThreeD>,
    type?: RR_WEBVIEWER_FILE_STATES,
    baseUrl?: string,
    authToken?: string,
    skybox?: boolean,
    ground?: boolean,
  ) {
    this.file = file;
    this.type = type;
    this.authToken = authToken;
    this.baseUrl = baseUrl;
    this.skybox = typeof skybox === 'undefined' ? true : skybox;
    this.ground = typeof ground === 'undefined' ? true : ground;

    if (
      this.type == RR_WEBVIEWER_FILE_STATES.CONVERT_JSON &&
      !Array.isArray(this.file) &&
      typeof this.file !== 'string' &&
      typeof this.file['obj'] !== 'undefined'
    ) {
      this.file = JSON.stringify(
        this.convertFileToWebviewerJSON(this.file).jsonObj,
      );
    } else if (Array.isArray(this.file)) {
      const jsonObjArray: Array<RRWebviewerJsonSingle> = [];
      this.file.forEach((singeFile) => {
        if (this.type == RR_WEBVIEWER_FILE_STATES.JSON_LIST) {
          jsonObjArray.push(this.convertFileToWebviewerJSON(singeFile).jsonObj);
        } else if (this.type == RR_WEBVIEWER_FILE_STATES.JSON_OBJECT_LIST) {
          jsonObjArray.push(singeFile);
        }
      });
      this.file = JSON.stringify(jsonObjArray);
    }
  }
  convertFileToWebviewerJSON(file: {
    obj: string;
    texture?: string;
  }): RRWebviewerJsonSingle {
    const jsonSingle: RRWebviewerJsonSingle = new RRWebviewerJsonSingle();

    jsonSingle.jsonObj = {
      version: 2,
      scene: {
        defaultEnvironment: {
          createGround: this.ground,
          createSkybox: this.skybox,
          groundColor: [0.7, 0.7, 0.7],
          skyboxColor: [2, 2, 2],
          skyboxSize: 200,
          groundSize: 5,
        },
        nodes: [
          {
            name: 'obj_mesh',
            type: 'Mesh',
            uri: '',
          },
          {
            name: 'Orbit',
            type: 'ArcRotateCamera',
            target: ['obj_mesh'],
            horizontalAngle: 90,
            useFramingBehavior: true,
            useAutoRotationBehavior: false,
            wheelPrecision: 100,
            maxZ: 10000,
            minZ: 0.01,
            children: [
              {
                name: 'Headlight',
                type: 'DirectionalLight',
                direction: [0, 0, 1],
                diffuse: [0.7, 0.7, 0.7],
                specular: [0.25, 0.25, 0.25],
              },
            ],
          },
        ],
      },
    };

    if (typeof file.obj !== 'undefined' && file.obj) {
      jsonSingle.jsonObj.scene.nodes[0].uri = file.obj;

      let extension = file.obj;
      if (extension.indexOf('?') > -1) {
        extension = extension.substring(0, extension.indexOf('?'));
      }
      extension = extension.substr(
        extension.lastIndexOf('.'),
        extension.length,
      );

      if (extension != '.glb') {
        jsonSingle.jsonObj.scene.nodes[0]['material'] = {
          name: 'obj_material',
          type: 'StandardMaterial',
          backFaceCulling: false,
        };
      }
    }
    if (typeof file.texture !== 'undefined' && file.texture) {
      const material = {
        name: 'obj_material',
        type: 'StandardMaterial',
        emissiveColor: [1, 1, 1],
        diffuseTexture: {
          uri: file.texture,
        },
        disableLighting: true,
        backFaceCulling: false,
      };
      jsonSingle.jsonObj.scene.nodes[0]['material'] = material;
    }

    return jsonSingle;
  }
}
